<template>
  <div tabindex="0" @click="handleCardClick" class="planned-video-card">
    <video-thumbnail
      :imageUrl="video.thumbnail_url"
      :thumbnailSize="thumbnailSize"
    >
      <span
        v-if="removable"
        @click.stop="handleCardRemoveButtonClick"
        class="thumbnail__trash-svg"
      >
        <TrashCanSVG />
      </span>
    </video-thumbnail>
    <VideoCardContent
      :nom="video.title"
      :marque="video.brand ? video.brand.name : ''"
      :description="video.description"
      :thematique="video.theme ? video.theme.name : ''"
    />
  </div>
</template>

<script>
import VideoThumbnail from "@/components/VideoThumbnail.vue"
import VideoCardContent from "@/components/VideoCardContent.vue"
import TrashCanSVG from "@/assets/svg/trash-can.svg"
import { deletePlanningVideo } from "@/api/plannings"
import { Message } from "element-ui"

export default {
  props: {
    planningId: Number,
    video: {
      type: Object,
      required: true
    },
    thumbnailSize: String,
    removable: {
      type: Boolean,
      default: true
    }
  },
  components: {
    VideoThumbnail,
    VideoCardContent,
    TrashCanSVG
  },
  methods: {
    handleCardClick() {
      // open modal here
      this.$store.dispatch("openModal", {
        name: "grouping-planned-video",
        payload: {
          plannedVideo: this.video
        }
      })
    },
    handleCardRemoveButtonClick() {
      deletePlanningVideo({
        videoId: this.video.id,
        planningId: this.planningId
      })
        .then(() => {
          Message.success("Vidéo supprimée")
          this.$emit("refreshPlanning")
        })
        .catch(() => {
          // Message.error("Vidéo n'a pas été supprimée")
        })
    }
  }
}
</script>

<style scoped rel="stylesheet/scss" lang="scss">
@import "@/styles/variables.scss";
.planned-video-card {
  color: white;
  position: relative;
  width: 100%;

  &:hover .video-thumbnail,
  &:focus .video-thumbnail {
    border: 2px solid $color-accent;
    border: 2px solid var(--color-accent, $color-accent);
  }
  .thumbnail {
    &__trash-svg {
      border-radius: 50%;
      padding: 5px 8px;
      position: absolute;
      display: inline-block;
      top: 3px;
      left: 5px;
      cursor: pointer;
      fill: $color-secondary;
      fill: var(--color-secondary, $color-secondary);
      transition: background 0.3s ease, fill 0.3s ease;
      &:hover,
      &:focus {
        background: #fbac2eb8;
        fill: white;
      }
    }
  }
}
</style>
